import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'risk-tolerance',
  template: require('./risk-tolerance.component.html')
})
export class RiskToleranceComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  updateOptionValue(event) {

  }

  helpMeDecide(event) {
    this.modal.questionnaire();
  }

}
